import ConduitePage from '../../pages/Conduite';
import { SurveillantLayout } from '../SurveillantLayout';

export default function ConduiteWrapper() {
  return (
    <SurveillantLayout title="Conduite" fullWidth>
      <ConduitePage />
    </SurveillantLayout>
  );
}
